import { useEffect, useState } from "react";
import CustomerChart from "./CustomerChart";
import formatMoney from "../../../../utils/formatMoney";
import { useQuery } from "@tanstack/react-query";
import { handleFetchTopCreditors } from "../../../../api/customers";
import CreditorsList from "./CreditorsList";

export default function CreditMetrics({ businessId, companyNo }: any) {
  const [listModal, setListModal] = useState<boolean>(false);

  const params = `limit=10`;
  const { data: customers } = useQuery({
    queryKey: ["metrics", businessId],
    queryFn: () => handleFetchTopCreditors({ businessId, params }),
  });

  useEffect(() => {}, [businessId, companyNo]);
  return (
    <div className="">
      <div className="flex items-center justify-between bg-gray-100 border-b border-t p-2">
        <div className="font-bold">Top 10 Customers with High Credit Limit</div>
        <button
          onClick={() => setListModal(true)}
          className="border py-1 px-2 bg-white hover:bg-gray-50"
        >
          View All
        </button>
      </div>
      <div className="grid grid-cols-12">
        <div className="col-span-12 sm:col-span-6">
          <div className="" style={{ height: 240 }}>
            <CustomerChart customers={customers?.records} />
          </div>
        </div>
        <div className="col-span-12 sm:col-span-6 pr-4">
          <div className="flex justify-between border-b">
            <div className="flex items-center">
              <div className="w-12 font-bold">Rank</div>
              <div className="font-bold">Customer</div>
            </div>
            <div className="font-bold">Sum of Credit Limit</div>
          </div>
          {customers?.records?.map((item: any, index: number) => (
            <div className="flex justify-between border-b" key={index}>
              <div className="flex items-center">
                <div className="w-12">{index + 1}.</div>
                <div className="">
                  {item?.account} - {item?.name}
                </div>
              </div>
              <div className="">{formatMoney(item?.currCredit)}</div>
            </div>
          ))}
        </div>
      </div>

      <CreditorsList
        isVisible={listModal}
        setVisible={setListModal}
        businessId={businessId}
        companyNo={companyNo}
      />
    </div>
  );
}
